import { TProps } from './types/TProps';

export const Divider = ({ vertical = false, className = '' }: TProps) => (
  <div
    className={`self-center ${vertical ? 'h-[41px] w-px border-r border-[var(--color-text-muted)]' : 'mb-[15px] mt-[5px] h-px w-full bg-[var(--color-divider)]'} ${className}`.trim()}
  />
);
